// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './chartNoData.scss';

// Assets
import NoDataFound from '../../static/images/noDataFound.png';

/**
 * ChartNoData Component
 *
 * @param {string} title - React component
 * @param {string} subtitle - React component
 * @param {string} customClass - React component
 */

const ChartNoData = ({ customClass, title, subtitle }) => (
    <div className={`nodata-wrapper ${customClass}`} id="nodata-modal">
        <img src={NoDataFound} alt="No Data Found" />
        <p className="nodata-title">{title}</p>
        <p className="nodata-subtitle">{subtitle}</p>
    </div>
);

ChartNoData.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    customClass: PropTypes.string,
};

export default ChartNoData;
